// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__tN6fY","Title":"Header_Title__Y9dxg","SideButtonContainer":"Header_SideButtonContainer__Aw9Az"};